import { FaMobile } from "react-icons/fa";
import { urlHttpGov } from "../../../../services/urls";
import { ICity } from "../../../../interfaces";
import Waves from "../../../../components/Waves";

interface IProps {
    primaryColor: string;
    secondaryColor: string;
    darkMode?: boolean;
    city?: ICity;
}

const PhoneMockupLogin = ({ primaryColor, secondaryColor, darkMode = false, city }: IProps) => {

    return (
        <div
            style={{
                width: 300,
                height: 570,
                minWidth: 300,
                borderRadius: 42,
                background: darkMode ? "#292929" : "#F1F3F5",
                overflow: "hidden",
                border: "8px solid #111",
                fontFamily: "system-ui, -apple-system, sans-serif",
                display: "flex",
                flexDirection: "column",
            }}
        >

            <div style={{ textAlign: "center", marginTop: 16, flexDirection: "column", justifyContent: 'center', gap: 0, display: "flex", alignItems: "center" }}>
                <img
                    style={{
                        width: 100,
                    }}
                    src={`${urlHttpGov}/logo_county/${city?.logo_light}`}
                    alt='Logo Município'
                />
                <div
                    style={{
                        marginTop: 15,
                        fontSize: 10,
                        color: "#8b8b8b"
                    }}
                >
                    Município selecionado: {city?.city} - {city?.uf}
                </div>
                <div style={{
                    fontSize: 10,
                    fontWeight: 500,
                    color: primaryColor
                }}>
                    Alterar
                </div>
            </div>

            <div style={{ padding: 12, marginTop: 8 }}>
                <div style={{ fontSize: 8, fontWeight: 400, color: "#8b8b8b" }}>
                    Telefone
                </div>
                <div style={{
                    backgroundColor: darkMode ? "#383838" : "#fff",
                    fontSize: 11,
                    padding: '4px 10px 4px 10px',
                    borderRadius: 2,
                    color: "#8b8b8b",
                    border: '1px solid #8b8b8b5b',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    display: 'flex'
                }}>
                    <div>Digite seu telefone</div>
                    <FaMobile style={{ color: "#8b8b8b", fontSize: 18 }} />
                </div>
            </div>
            <div style={{ textAlign: "center", flexDirection: "column", justifyContent: 'center', gap: 0, display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        marginTop: 4,
                        marginBottom: 2,
                        fontWeight: 500,
                        color: "#8b8b8b",
                        fontSize: 9
                    }}
                >
                    Receber código via
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        fontSize: 11,
                        gap: 28
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div
                            style={{
                                width: 14,
                                height: 14,
                                borderRadius: '50%',
                                border: '1px solid #8b8b8b',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: primaryColor,
                                }}
                            ></div>
                        </div>
                        <span style={{color: darkMode ? '#fff' :  "#000"}}>Whatsapp</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                border: '1px solid #8b8b8b',
                            }}
                        ></div>
                        <span style={{color: darkMode ? '#fff' :  "#000"}}>SMS</span>
                    </div>
                </div>
            </div>
            <div style={{
                backgroundColor: primaryColor,
                padding: 8,
                marginLeft: 10,
                marginRight: 10,
                borderRadius: 4,
                marginTop: 20,
                textAlign: 'center',
                color: '#fff',
                fontWeight: 'bold'
            }}>
                Continuar
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginLeft: 10,
                marginRight: 10,
                marginTop: 14
            }}>
                <div style={{
                    fontSize: 10,
                    fontWeight: 500,
                    color: primaryColor
                }}>
                    Recuperar acesso
                </div>
                <div style={{
                    fontSize: 10,
                    fontWeight: 500,
                    color: primaryColor
                }}>
                    Criar uma nova senha
                </div>
            </div>

            <div style={{ textAlign: "center", marginTop: 16, flexDirection: "column", justifyContent: 'center', gap: 0, display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        marginTop: 4,
                        fontWeight: 500,
                        color: "#8b8b8b",
                        fontSize: 8
                    }}
                >
                    Precisando de ajuda?
                </div>

                <div style={{
                    fontSize: 10,
                    fontWeight: 500,
                    color: primaryColor
                }}>
                    <u>Suporte técnico</u>
                </div>
            </div>
            <div style={{ position: 'relative', height: 200 }}>
                <Waves lightColor={primaryColor} baseColor={secondaryColor} />
            </div>

        </div>
    );
};

export default PhoneMockupLogin;